<div class="select-data-menu-container" (clickOutside)="closeMenu()" appClickOutsideComponent>
  <div class="header-container">
    <div class="text-container">
      <h3>{{ 'view_translations.show' | translate | titlecase }}</h3>
      <h4>{{ 'view_translations.show_max_4' | translate | titlecase }}</h4>
    </div>
    <div class="close-button-container">
      <button class="close-button" (click)="closeMenu()">
        <nb-icon icon="cross" pack="icomoon"></nb-icon>
      </button>
    </div>
  </div>
  <div class="options-container">
    <div class="single-container" *ngFor="let option of filterOptions; let i = index">
      <label class="filter-element">
        <input
          type="checkbox"
          name="{{ option.name }}"
          (change)="checkboxValue($event, option, i)"
          [checked]="checkIfChecked(option)"
          [disabled]=" option.status === true && currentFilters.length === 1 " />
        <div class="element-text global-transition" [ngClass]="{'active': option.status}">
          {{ 'view_translations.' + option.translation | translate | titlecase }}
        </div>
        <span class="checkmark"></span>
        <span class="colorDot" [ngClass]="option.name ?? ''"></span>
      </label>
    </div>
  </div>
</div>
